import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "overview" */ "../views/Home.vue"),
    children: [
      {
        path: "/overview",
        name: "Overview",
        component: () =>
          import(/* webpackChunkName: "overview" */ "../views/Overview.vue")
      },
      {
        path: "/automations",
        name: "Automations",
        redirect: { name: "AutomationList" },
        component: () =>
          import(
            /* webpackChunkName: "automation" */ "../views/Automations.vue"
          ),
        children: [
          {
            path: "/list",
            name: "AutomationList",
            component: () =>
              import(
                /* webpackChunkName: "automation" */ "../views/Automation/AutomationList.vue"
              )
          },
          {
            path: "/welcomenotifications",
            name: "WelcomeNotifcation",
            redirect: { name: "WelcomeNotifcationFlow" },
            component: () =>
              import(
                /* webpackChunkName: "automation" */ "../views/Automation/WelcomeNotification.vue"
              ),
            children: [
              {
                path: "notification",
                name: "WelcomeNotifcationFlow",
                component: () =>
                  import(
                    /* webpackChunkName: "automation" */ "../views/Automation/WelcomeNotification/WelcomeNotificationFlow.vue"
                  )
              },
              {
                path: "notification/:index",
                name: "WelcomeNotificationConfig",
                component: () =>
                  import(
                    /* webpackChunkName: "automation" */ "../views/Automation/WelcomeNotification/WelcomeNotificationConfig.vue"
                  )
              }
            ]
          },

          {
            path: "/abandonedcart",
            name: "AbandonedCart",
            redirect: { name: "AbandonedCartFlow" },
            component: () =>
              import(
                /* webpackChunkName: "automation" */ "../views/Automation/AbandonedCart.vue"
              ),
            children: [
              {
                path: "notification",
                name: "AbandonedCartFlow",
                component: () =>
                  import(
                    /* webpackChunkName: "automation" */ "../views/Automation/AbandonedCartNotification/AbandonedCartNotificationFlow.vue"
                  )
              },
              {
                path: "notification/:index",
                name: "AbandonedCartConfig",
                component: () =>
                  import(
                    /* webpackChunkName: "automation" */ "../views/Automation/AbandonedCartNotification/AbandonedCartNotificationConfig.vue"
                  )
              }
            ]
          },
          {
            path: "/ordershipping",
            name: "OrderShipping",

            redirect: { name: "OrderShippingFlow" },
            component: () =>
              import(
                /* webpackChunkName: "ordershipping" */ "../views/Automation/OrderShipping.vue"
              ),
            children: [
              {
                path: "/otification",
                name: "OrderShippingFlow",
                component: () =>
                  import(
                    /* webpackChunkName: "ordershipping" */ "../views/Automation/OrderShippingNotification/OrderShippingNotificationFlow.vue"
                  )
              },
              {
                path: "notification/:index",
                name: "OrderShippingConfig",
                component: () =>
                  import(
                    /* webpackChunkName: "ordershipping" */ "../views/Automation/OrderShippingNotification/OrderShippingNotificationConfig.vue"
                  )
              }
            ]
          }
        ]
      },
      {
        path: "/subscribers",
        name: "Subscribers",
        component: () =>
          import(
            /* webpackChunkName: "subcribers" */ "../views/Subscribers.vue"
          )
      },
      {
        path: "/messagelogs",
        name: "MessageLogs",
        component: () =>
          import(
            /* webpackChunkName: "messagelogs" */ "../views/Automation/MessageLogs.vue"
          ),
        children: []
      },
      {
        path: "/optin",
        name: "Optin",
        redirect: { name: "OptinOptions" },
        component: () =>
          import(/* webpackChunkName: "Optin" */ "../views/Optin.vue"),
        children: [
          {
            path: "/options",
            name: "OptinOptions",
            component: () =>
              import(
                /* webpackChunkName: "Optin" */ "../views/Optin/OptinOptions.vue"
              )
          },
          {
            path: "/editcustom",
            name: "EditCustomOptin",
            component: () =>
              import(
                /* webpackChunkName: "Optin" */ "../views/Optin/EditCustomOptin.vue"
              )
          }
        ]
      },
      {
        path: "/analytics",
        name: "Analytics",
        component: () =>
          import(/* webpackChunkName: "overview" */ "../views/Analytics.vue")
      }
    ]
  },
  {
    path: "/plan",
    name: "Plan",
    component: () => import(/* webpackChunkName: "plan" */ "../views/Plan.vue")
  },

  {
    path: "/privacy-policy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "../views/PrivacyPolicy.vue")
  },
  {
    path: "/incident",
    component: () =>
      import(/* webpackChunkName: "incident" */ "../views/Incident.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue")
  },

  {
    path: "/redirect",
    name: "Redirect",
    component: () =>
      import(/* webpackChunkName: "overview" */ "../views/Redirect.vue")
  },
  {
    path: "/auth/:token",
    name: "AuthRedirect",
    component: () =>
      import(/* webpackChunkName: "overview" */ "../views/AuthRedirect.vue")
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
